import React from 'react';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import { Grid } from 'react-bootstrap';
import Pusher from 'react-pusher';

import Header from '../components/Header';
import Footer from '../components/Footer';
import actions from '../redux/actions';
import actionTypes from '../redux/actionTypes';

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = { authenticated: false };
  }

  componentWillMount() {
    this.checkAuth(this.props.isAuthenticated);
  }

  componentWillReceiveProps(nextProps) {
    const {
      isAuthenticated,
      authStatus,
      profile,
      profileStatus,
      location,
      router,
      dispatch,
    } = nextProps;

    if (
      this.props.authStatus !== authStatus &&
      authStatus === actionTypes.INVALID_TOKEN
    ) {
      dispatch(
        actions.alert(
          'error',
          'You have been logged out. Please sign in again to continue.'
        )
      );
      router.push(`/login?next=${location.pathname}`);
    } else if (
      this.props.profileStatus !== profileStatus &&
      profileStatus === actionTypes.PROFILE_GET_ERROR
    ) {
      dispatch(
        actions.alert('error', 'Wrong username and password. Please try again.')
      );
      router.push(`/login?next=${location.pathname}`);
    } else {
      this.checkAuth(isAuthenticated);
      if (
        this.props.profileStatus !== profileStatus &&
        profileStatus === actionTypes.PROFILE_GET_SUCCESS
      ) {
        this.checkProfile(profile);
      }
    }

    // If the current subscription billingEndDate is today, cancel the subscription and let the users to upgrade the subscription.
    // if (this.props.payment.status !== payment.status && payment.status === actionTypes.PAYMENT_GET_SUBSCRIBE_SUCCESS) {
    //   if (payment.subscription && payment.subscription.subscriptionExpiresStatus) {
    //     this.props.dispatch(actions.alert('error', 'Your account has been downgraded to the free tier. You can upgrade again by clicking on your profile picture, choosing "Edit Profile" and selecting the Premium Account option.'));
    //     dispatch(actions.cancelSubscribe({}));
    //   }
    // }
  }

  checkProfile(profile) {
    const page = this.props.children.props.route.page;

    if (page !== 'profile') {
      const { name, address, city, state, postal /*tel, phone_verified*/ } =
        profile;
      // const verified = (name && address && city && state && postal && tel && phone_verified);
      const verified = name && address && city && state && postal;

      if (!verified) {
        // Force redirected to user profile page
        this.props.dispatch(
          actions.alert('error', 'Please complete your profile first.')
        );
        this.props.router.push(`/user`);
      }
    }
  }

  checkAuth(isAuthenticated) {
    const { location, dispatch, router } = this.props;

    if (!isAuthenticated) {
      const token = cookie.load('token');

      if (!token) {
        router.push(`/login?next=${location.pathname}`);
      } else {
        dispatch(actions.setLoggedIn());
        dispatch(actions.getProfile());
        dispatch(actions.getSubscription());
        dispatch(actions.getRoles());
        dispatch(actions.getOwnershipTypes());
        dispatch(actions.getContractBlocks());
        dispatch(actions.getWorkTypes());
        dispatch(actions.getSubWorkTypes());
      }
      this.setState({ authenticated: false });
    } else {
      this.setState({ authenticated: true });
    }
  }

  onPusherCompleted = (data) => {
    const { location } = this.props;

    if (location.pathname.indexOf(`dealroom/${data.deal}/`) === -1) {
      window.location.reload();
    }
  };

  render() {
    return this.state.authenticated === true ? (
      <div className="main-container">
        <Header />
        <Grid>{this.props.children}</Grid>
        <Footer />
        <Pusher
          channel="deal-detail"
          event="deal-completed"
          onUpdate={this.onPusherCompleted}
        />
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  authStatus: state.auth.status,
  profile: state.profile,
  profileStatus: state.profile.status,
  payment: state.payment,
});

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// src/containers/Main.jsx